<div class="wrapper__headerComponent container my-5">
  <div class="row">
    <div class="d-flex flex-row align-items-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{ nombreCompleto }}</h2>
    </div>
  </div>
  <div class="container-example-linea-avance-govco mx-0 my-5">
    <div
      class="linea-avance-govco ih-linea-avance-govco m-0 p-0"
      id="lineaAvance3">
      <div class="px-5">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: 15%"
            aria-valuenow="15"
            aria-valuemin="0"
            aria-valuemax="100"></div>
        </div>
        <div class="items-header-linea-avance-govco">
          <div class="header-linea-avance-govco active-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance31"
              percentage="12"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(1)"
              aria-label="Atrás">
              <span>1</span>
            </button>
            <span class="title-linea-avance-govco">{{
              comunText['datos-demandante']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance32"
              percentage="25"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(2)"
              aria-label="Atrás">
              <span>2</span>
            </button>
            <span class="title-linea-avance-govco">{{
              comunText['datos-demandado']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance33"
              percentage="38"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(3)"
              aria-label="Atrás">
              <span>3</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['reclamo-directo']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance34"
              percentage="50"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(4)"
              aria-label="Atrás">
              <span>4</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['proteccion-requiere']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance35"
              percentage="63"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(5)"
              aria-label="Atrás">
              <span>5</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['pretenciones']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance36"
              percentage="75"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(6)"
              aria-label="Atrás">
              <span>6</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['fundamentos-derecho']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance37"
              percentage="88"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(7)"
              aria-label="Atrás">
              <span>7</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['pruebas']
            }}</span>
          </div>
          <div class="header-linea-avance-govco">
            <button
              class="indicator-linea-avance-govco"
              type="button"
              data-la-target="#itemlineaAvance38"
              percentage="100"
              onClick="clickHorizontalAdvanceLine(event)"
              (click)="anterior(8)"
              aria-label="Atrás">
              <span>8</span>
            </button>
            <span class="title-linea-avance-govco">{{
              proconText['tramite-sic-procon']['notificaciones']
            }}</span>
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance31"
        class="body-linea-avance-govco active-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <app-recuadro-justino></app-recuadro-justino>
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-datos-demandante
              (continuar)="siguiente($event, 1)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC"
              [archivosPreCargados]="archivosPreCargados"
              (demandanteEmit)="getFormDemandante($event)"
              (apoderadoEmit)="getFormApoderado($event)"/>
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance32"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-datos-demandado
              (continuar)="siguiente($event, 2)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC"
              (demandadoEmit)="getFormDemandado($event)"
              (anexo)="siguiente($event, 1)"/>
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance33"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-reclamo-directo
              *ngIf="festivos.length>0"
              (continuar)="siguiente($event, 3)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC"
              (reclamoEmit)="getFormReclamo($event)"/>
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance34"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-proteccion-que-requiere
              (continuar)="siguiente($event, 4)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC" />
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance35"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-pretensiones
              (continuar)="siguiente($event, 5)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC"
              (pretension)="getPretenciones($event.listaPretenciones)"/>
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance36"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-fundamentos-de-derecho
              (continuar)="siguiente($event, 6)"
              (guardarSinEnviar)="guardarSinEnviarTramite($event)"
              [tramiteSic]="tramiteSIC" />
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance37"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-pruebas
              [style]="{ display: paso === 7 ? 'block' : 'none' }"
              *ngIf="paso === 7"
              [archivosPreCargados]="archivosPreCargados"
              [idTramite]="idTramite"
              [tramiteSic]="tramiteSIC"
              [nombreCortoLimpioTramite]="nombreCortoLimpio"
              (volver)="anterior($event)"
              (guardarSinEnviar)="subirArchivos($event, 7, true)"
              (continuar)="subirArchivos($event, 8, false)" />
          </div>
        </div>
      </div>
      <div
        id="itemlineaAvance38"
        class="body-linea-avance-govco"
        data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <app-notificaciones
              *ngIf="ultimoPaso"
              [tramiteSic]="tramiteSIC"
              (volver)="anterior($event)"
              (guardarSinEnviarTramite)="guardarSinEnviarTramite($event)"
              (enviarTramite)="enviarTramite($event)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
